import React, { ReactNode } from 'react';
import { Location, LocationDescriptor } from 'history';
import { Link as ReactRouterLink } from 'react-router-dom';

export interface LinkProps extends Omit<React.ComponentPropsWithRef<ReactRouterLink>, 'to' | 'referrerPolicy'> {
	disabled?: boolean;
	to?: LocationDescriptor | ((location: Location) => LocationDescriptor);
	href?: string;
	styles: string;
	children: ReactNode;
}

export function Link({ to, href, styles, children, ...rest }: LinkProps) {
	return to ? (
		<ReactRouterLink className={styles} to={to} {...rest}>
			{children}
		</ReactRouterLink>
	) : (
		<a className={styles} href={href} {...rest}>
			{children}
		</a>
	);
}
